<template>
  <ListView
    modelName="PurchaseOrder"
    perm="purchase.menu_purchase_order"   
    svg="icon_side_order" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_purchase_order"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="PurchaseOrder"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelectedMain"
    :isLoading="isLoading"
    borderColor="#4099DA"
    backColor="#E5F4FF"
    tourId="291615"
    :comparer="(a,b)=>a.orderNo == b.orderNo"    
    :postAddHandler="submitBundleAddOrderItemRun"
    :popup="popup"            
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseOrderStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.orderNo}}</GridItem>
    <GridItem :slot="listSlots[2]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.orderDate | date }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.requestDate | date }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlagsHasServices }}</GridItem>    
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem>     
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.currencyCode | currency }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode) }}</GridItem>  
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ ( item.counterpart ? item.counterpart.taxType : null ) | taxTypes }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.orderFlag | orderFlags}}</GridItem>    
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:'' }}</GridItem>       
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.segmentId | segment}}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.pic | user }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.refNo }}</GridItem>

    <GridItem :slot="listSlots[17]" slot-scope="{ item }" :right="true">{{ item.advanceAmountFC | amountFC(item.currencyCode)  }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.dueDate | date }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }" :right="true">{{ item.advanceBalanceAmountFC | amountFC(item.currencyCode)  }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }" :right="true">{{ item.advanceCurrentAmountFC | amountFC(item.currencyCode)  }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }" :right="true">{{ item.advanceWriteoffPendingAmountFC | amountFC(item.currencyCode)  }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.importNo }}</GridItem>    
    <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :electronicBookMode="tenantSettings.electronicBookMode" :getKeyValue="(obj)=>obj.orderNo" >
        <template v-if="hasLicenseImport">
          <ListViewMenu title="支払処理" @click="showAdvancePaymentDialog" />
        </template>
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="['検索条件','取引先区分','予備項目']">
        <FilterBox title="発注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="発注管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="受注番号" :value.sync="params.salesOrderNo" @click="handler" />
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <FilterBox title="仕入先名称" :value.sync="params.counterpartName" @click="handler"/>
        <AtcCounterpart title="仕入先" :value.sync="params.counterpart" :needsSupplier="true" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>           
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />                     
        <Calendar title="発注日(From)" :value.sync="params.orderDateFrom" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.orderDateFromFlag"/>
        <Calendar title="発注日(To)" :value.sync="params.orderDateTo" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.orderDateToFlag"/>
        <FilterBox title="発注金額(From)" :value.sync="params.dealAmountFcFrom" :isNumber="true" @click="handler" />
        <FilterBox title="発注金額(To)" :value.sync="params.dealAmountFcTo" :isNumber="true" @click="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
       <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />                
        <ComboBox title="状態" :value.sync="params.state" :list="hasLicenseCurrency ? 'purchaseOrderStatus' : 'purchaseOrderStatusNoLicenseCurrency'" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <ComboBox slot="tab1" title="category_1" :value.sync="params.category1" list="category_1" @changed="handler" />
        <ComboBox slot="tab1" title="category_2" :value.sync="params.category2" list="category_2" @changed="handler" />
        <ComboBox slot="tab1" title="category_3" :value.sync="params.category3" list="category_3" @changed="handler" />
        <ComboBox slot="tab1" title="category_4" :value.sync="params.category4" list="category_4" @changed="handler" />
        <ComboBox slot="tab1" title="category_5" :value.sync="params.category5" list="category_5" @changed="handler" />
        <ComboBox slot="tab1" title="category_6" :value.sync="params.category6" list="category_6" @changed="handler" />

        <FilterBox slot="tab2" title="voucher_text1" :value.sync="params.reserveText1" @click="handler"   />
        <FilterBox slot="tab2" title="voucher_text2" :value.sync="params.reserveText2" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text3" :value.sync="params.reserveText3" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text4" :value.sync="params.reserveText4" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text5" :value.sync="params.reserveText5" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text6" :value.sync="params.reserveText6" @click="handler" />
        <ComboBox slot="tab2" title="voucher_list1" :value.sync="params.reserveList1" list="category_31" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list2" :value.sync="params.reserveList2" list="category_32" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list3" :value.sync="params.reserveList3" list="category_33" @changed="handler" />         
        <Calendar slot="tab2" title="voucher_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" />     
        <FilterBox slot="tab2" title="voucher_memo1" :value.sync="params.reserveMemo1" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo2" :value.sync="params.reserveMemo2" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo3" :value.sync="params.reserveMemo3" @click="handler"/> 
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','発注明細','記載事項','納入先詳細','予備項目','前払金情報','ワークフロー','更新履歴','添付ファイル']" :tabVisibles="listView.isInsertMode ? tabVisiblesOnInsert: tabVisibles" :tabTooltips="[null,'選択した発注に紐づいている発注明細伝票を表示します。','任意に発注データに関わる詳細情報を編集できるタブです。','納入先の情報が編集できます。【納入区分】が【直送】の場合は商品の出荷先、【在庫】の場合は入庫する倉庫の情報が表示されます。','任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【取引先予備項目】から変更が可能です。内容は帳票に載せることができます。',null,null,null,null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item, editor}">
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">            
            <Button class="button" @click="showPurchaseOrderItems" caption="明細表示" :disabled="editor.isEdit || disabledShowItemButton" icon="arrow_downward" tooltip="選択した発注に紐づいている【発注明細】の一覧を表示します。"/>
            <!-- <Button class="button" @click="showBundleAddOrderItemDialog" caption="明細の追加" :disabled="editor.isEdit || disabledAddItemButton(item)" icon="add" tooltip="選択した発注に紐づく【発注明細】の登録を行います。"/> -->
            <!-- <Button class="button" @click="showSkuBundleAddOrderItemDialog" caption="明細SKUの追加" :disabled="editor.isEdit || disabledAddItemButton(item)" icon="add" tooltip="【SKU一覧】から【商品】に【SKU】を追加している場合、この機能からSKU別にまとめて明細を追加することができます。"/> -->
            <Button class="button" @click="showPurchaseDeliveryItem" caption="入荷明細表示" :disabled="disabledShowPurchaseDeliveryItemButton(item)" icon="arrow_forward" tooltip="選択した発注に紐づいている【入荷明細】の一覧を表示します。"/>
          </SplitButton>        
        </template>
        <template slot="menu_right" slot-scope="{item}">   
          <Button class="button" @click="showCreatePurchaseDelivery(false,true)" caption="入荷処理" v-if="! disabledOrderItemFuncButton(item)" :perm="$refs.mainList.perm + '.process'" :disabled="$refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading" />
          <Button class="button" @click="showCreatePurchaseDelivery(true,true)" caption="未着品処理" v-if="! disabledOrderItemFuncButton(item)" :perm="$refs.mainList.perm + '.process'" :disabled="$refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading" />
        </template>        
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="発注番号" :value.sync="item.orderNo" :editor="editor" :enabled="false" tooltip="先頭に”PO”がつく番号が初回保存時に自動で付与されます。この番号は手動で変更することができません。"/>
              <Calendar title="発注日" :value.sync="item.orderDate" :editor="editor" :required="true" :enabled="isEditable(item, false)"/>
              <AtcCounterpart title="仕入先" :value.sync="item.counterpart" :editor="editor" :needsSupplier="true" :required="true" :enabled="isEditable(item, false)" @update:value="onChangeCustomer(item, editor)"  tooltip="商品の発注を行う取引先です。【取引先一覧】の【取引先種別】が【仕入先】になっているデータが選択できます。"/>
              <Calendar title="希望納期" :value.sync="item.requestDate" :editor="editor" :enabled="isEditable(item, false)" :deletable="true" />
              <RadioButton title="納入区分" :value.sync="item.deliveryFlag" :list="$api.useStockFunction ? 'deliveryFlagsHasServices' : 'deliveryFlagsHasServicesNoStock'" :editor="editor" :enabled="isEditable(item, true)" :isDirectEditEnabled="false" @update:value="onChangeDeliveryFlag(item, editor)" tooltip="商品を在庫とするかお客様に直送するのかの区分が表示されます。【直送】にする為には受注から登録を行い【受注一覧】から【発注処理】または【受注明細】タブから【明細発注処理】をする必要があります。"/>
              <AtcCounterpart title="入庫倉庫" :value.sync="item.warehouse" :editor="editor" :needsWarehouse="true" :enabled="isEditable(item, false, isStock)" :isDirectEditEnabled="false" @update:value="onChangeWarehouse(item, editor)"  v-if="item.deliveryFlag == DeliveryFlags.Stock" :key="1" tooltip="発注した商品を入荷時に保管する倉庫です。【取引先一覧】の【取引先種別】が【倉庫】になっているデータが選択できます。"/>
              <AtcCounterpart title="納入先" :value.sync="item.receiver" :editor="editor" :needsCustomer="true" :needsReceiver="true" :required="isEditable(item, false, isDirect)" :enabled="isEditable(item, false, isDirect)" :isDirectEditEnabled="false" @update:value="onChangeReceiver(item, editor)"  v-if="item.deliveryFlag == DeliveryFlags.Direct" :key="2" tooltip="商品の出荷先です｡【納入区分】が【直送】の場合のみ表示されます。【取引先種別】が【得意先】または【納入先】になっているデータが選択できます。"/>
              <ComboBox title="取引通貨" v-if="hasLicenseCurrency" :value.sync="item.currencyCode" list="currency" :required="true" :editor="editor" :enabled="isEditable(item, false)" nullValue="" />                            
              <NumericBox title="発注金額" :value.sync="item.dealAmountFC" :editor="editor" :enabled="false" :decimals="$api.decimals[item.currencyCode]" tooltip="登録されている【発注明細】の【発注数量】×【単価】の合計金額が表示されます。"/>              
              <TextBox title="税計算区分" :value="(item.counterpart ? item.counterpart.taxType : '') | taxTypes" :editor="editor" :enabled="false" tooltip="【仕入先】に設定した仕入先の【税計算区分】が表示されます。"/>                            
              <TextBox title="登録番号" :value="(item.counterpart ? item.counterpart.invoiceNo : '')" :editor="editor" :enabled="false" tooltip="取引先マスタに設定されている適格請求書発行事業者の登録番号が表示されます。<br>発行事業者とそれ以外で【税区分】を分けると「仕入元帳(税区分集計)」で集計できます。"/>
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="isEditable(item,false) && !item.orderFlag"  tooltip="登録済み案件の選択、新規案件の作成が行えます。"/>                            
              <AtcSegment title="部門" :value.sync="item.segment" :editor="editor" :required="true" :enabled="isEditable(item, false) && !item.orderFlag" tooltip="発注を担当する部門です。【部門一覧】のデータから選択することができます。【納入区分】が【直送】の場合は受注データと同じ部門を選択します。"/>
              <AutoComplete title="担当者" :value.sync="item.pic" :editor="editor" list="user" :required="true" :enabled="isEditable(item, false)" tooltip="案件の担当者です。【ユーザー】のデータを選択することができます。"/>
              <TextBox title="受注区分" :value="item.orderFlag ? '受注あり' : '受注なし'" :editor="editor" :enabled="false" tooltip="発注明細に対応する受注明細の有無を確認できます。受注を元に【発注処理】をした場合【受注あり】に、そうではない場合に【受注なし】になります。"/>
              <TextBox title="発注管理番号" :value.sync="item.refNo" :editor="editor" :enabled="isEditable(item, false)" length="30" tooltip="任意で登録する発注に対して管理番号を入力することができます。"/>
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="発注データを最後に更新した日時が表示されています。"/>
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_purchaseOrder" :required="$api.perms.hasWorkflow('purchaseOrder')" :enabled="$api.perms.hasWorkflow('purchaseOrder') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="発注時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【発注管理】になっているデータから選択ができます。"/>
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="発注データの現在の状態が表示されており､確定や業務処理を行う事で変化します。"/>                 
            </template>
          </EditPanel>
        </template>
        <!-- 発注明細タブ -->
        <template slot="tab1" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.orderNo" :voucherType="voucherTypes.PurchaseOrder" :voucherItemType="voucherTypes.PurchaseOrderItem" ref="purchaseOrderItems" :showCheckBox="true" :comparer="(a,b)=>a.auditNo == b.auditNo">
              <template slot="menu"  slot-scope="{parent}" >
              <SplitButton class="button" @click="showBundleAddOrderItemDialog" caption="明細の追加" :perm="$refs.mainList.perm + '.edit'"  :disabled="(editor.owner.isAdding == false && editor.isEdit) || disabledAddItemButton(item) || ($refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading)" icon="add" tooltip="選択した発注に紐づく【発注明細】の登録を行います。">
                <Button class="button" @click="showSkuBundleAddOrderItemDialog" caption="明細SKUの追加" :perm="$refs.mainList.perm + '.edit'" v-if="$api.useStockFunction" :disabled="editor.isEdit || disabledAddItemButton(item) || ($refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading)" tooltip="【SKU一覧】から【商品】に【SKU】を追加している場合、この機能からSKU別にまとめて明細を追加することができます。"/>
              </SplitButton>
              <Button class="button" @click="parent.onDelete().then(()=>$refs.mainList.reloadSelected())" :perm="$refs.mainList.perm + '.edit'"   caption="明細の削除" :disabled="editor.isEdit || disabledAddItemButton(item) || parent.isLoading" icon="delete"/>              
              <SplitButton class="button" @click="showCreatePurchaseDelivery(false)" caption="明細入荷処理" :perm="$refs.mainList.perm + '.process'"  :disabled="editor.isEdit || disabledOrderItemFuncButton(item) || ($refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading)" tooltip="発注した商品が倉庫に入荷した際に行う処理です。【納入区分】が直送の場合､入荷処理を行うと同時に出荷データが作成されます。">
                <Button class="button" @click="showCreatePurchaseDelivery(true)" caption="明細未着品処理" :perm="$refs.mainList.perm + '.process'"  :disabled="editor.isEdit || disabledOrderItemFuncButton(item) || ($refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading)" tooltip="発注した商品が実際に倉庫や出荷先に届く前に仕訳を発生させる処理です。尚､同時に数量も在庫データに反映され､直送の場合は出荷データが作成されます。"/>
              </SplitButton>
              <SplitButton class="button" @click="itemClosedQuery(true)" caption="明細クローズ処理" :perm="$refs.mainList.perm + '.process'" :disabled="editor.isEdit || disabledOrderItemFuncButton(item) || ($refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading)" tooltip="選択された【発注明細】に対してクローズ処理を行い、発注残数量を0にします。発注残を入荷せずに発注伝票を完了させたい場合に利用します。">
                <Button class="button" @click="itemClosedQuery(false)" caption="明細クローズ解除処理" :perm="$refs.mainList.perm + '.process'" :disabled="editor.isEdit || disabledOrderItemCloseCancelFuncButton(item) || ($refs.purchaseOrderItems && $refs.purchaseOrderItems.isLoading)" tooltip="選択された【発注明細】に対してクローズ解除処理を行い、クローズ数量を0にします。クローズして完了させた伝票のクローズを解除したい場合に利用します。"/>
              </SplitButton>
              </template>
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="発注明細" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();}">
                <PurchaseOrderItem slot-scope={popup} :popup="popup" :orderItemNo="parent.editItem ? parent.editItem.orderItemNo: null"/>
              </PopupEditor>                
          </GrdVoucherItem>
        </template>               
        <!-- 記載事項タブ -->
        <template slot="tab2" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 記載事項タブ 左側 -->
            <template slot="left">
              <TextBox title="決済条件" :value.sync="item.paymentTerm" :editor="editor" :enabled="isEditable(item, false)" length="50" tooltip="任意で決済に関わる情報を最大50文字まで入力でき、内容を帳票に載せることができます。"/>
              <TextBox title="特記事項" :value.sync="item.remark" :editor="editor" :enabled="isEditableNoComplete(item)" length="200" rows="10" tooltip="任意で特記したい情報を最大200文字まで入力できます。内容を帳票に載せることができます。"/>
            </template>
            <!-- 記載事項タブ 右側 -->
            <template slot="right">
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditableNoComplete(item)" length="200" rows="12" tooltip="任意で発注に関わる様々な情報を最大200文字まで入力できます。内容を帳票に載せることができます。"/>
            </template>
          </EditPanel>
        </template>
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :value.sync="item.outputReceiverName" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="担当部署名" :value.sync="item.outputReceiverPICSection" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="担当者" :value.sync="item.outputReceiverPIC" :editor="editor" :enabled="isEditable(item, false)" length="30" />
              <TextBox title="敬称" :value.sync="item.outputReceiverPICHonorificTitle" :editor="editor" :enabled="isEditable(item, false)" length="5" />
              <TextBox title="電話番号" :value.sync="item.outputReceiverTelNo" :editor="editor" :enabled="isEditable(item, false)" length="20" />
              <TextBox title="FAX番号" :value.sync="item.outputReceiverFaxNo" :editor="editor" :enabled="isEditable(item, false)" length="20" />
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <div style="display:flex;">
                <TextBox title="郵便番号" :value.sync="item.outputReceiverPostalCode" :editor="editor" :enabled="isEditable(item, false)" length="50" />
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="$api.getAddress(item.outputReceiverPostalCode).then(res => item.outputReceiverAddress1 = res)" caption="住所取得" :disabled="!isEditable(item, false)  || editor.isEdit ==false" tooltip="郵便番号から住所を取得します"/>
              </div>              
              <TextBox title="住所1" :value.sync="item.outputReceiverAddress1" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="住所2" :value.sync="item.outputReceiverAddress2" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="住所3" :value.sync="item.outputReceiverAddress3" :editor="editor" :enabled="isEditable(item, false)" length="50" />
            </template>
          </EditPanel>
        </template>        
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 予備項目タブ 左側 -->
            <template slot="left">
              <TextBox title="voucher_text1" :value.sync="item.reserveText1" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="voucher_text2" :value.sync="item.reserveText2" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="voucher_text3" :value.sync="item.reserveText3" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="voucher_text4" :value.sync="item.reserveText4" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="voucher_text5" :value.sync="item.reserveText5" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <TextBox title="voucher_text6" :value.sync="item.reserveText6" :editor="editor" :enabled="isEditable(item, false)" length="50" />
              <AutoComplete title="voucher_list1" :value.sync="item.reserveList1" :editor="editor" list="category_31" :enabled="isEditable(item, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list2" :value.sync="item.reserveList2" :editor="editor" list="category_32" :enabled="isEditable(item, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list3" :value.sync="item.reserveList3" :editor="editor" list="category_33" :enabled="isEditable(item, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
            </template>
            <!-- 予備項目タブ 右側 -->
            <template slot="right">
              <Calendar title="voucher_date1" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable(item, false)" :deletable="true" />
              <Calendar title="voucher_date2" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable(item, false)" :deletable="true" />
              <Calendar title="voucher_date3" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable(item, false)" :deletable="true" />
              <TextBox title="voucher_memo1" :value.sync="item.reserveMemo1" :editor="editor" :enabled="isEditable(item, false)" length="200" rows="2" />
              <TextBox title="voucher_memo2" :value.sync="item.reserveMemo2" :editor="editor" :enabled="isEditable(item, false)" length="200" rows="2" />
              <TextBox title="voucher_memo3" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEditable(item, false)" length="200" rows="2" />
            </template>
          </EditPanel>
        </template>

        <!-- 支払情報タブ -->
        <template slot="tab5" slot-scope="{item,editor }">
          <EditPanel class="cx_payment_tab">
            <!-- 支払情報タブ 左側 -->
              <template slot="left">
                <NumericBox title="前払金請求額" :value.sync="item.advanceAmountFC" :editor="editor" :enabled="isEditable(item, false)" min="0" :max="item.dealAmountFC < 0 ? 0 : item.dealAmountFC" decimals="2" />
                <Calendar title="支払予定日" :value.sync="item.dueDate" :editor="editor" :required="item.advanceAmountFC != 0" :enabled="isEditable(item, false)" :deletable="true" />
            </template>
            <!-- 支払情報タブ 右側 -->
            <template slot="right">
              <div class="cx_totals">
                <NumericBox title="支払金額合計(完了)" :value="totalPaymentAmountFC" :enabled="false" decimals="0" />
                <NumericBox title="支払金額合計(確定待ち)" :value.sync="totalPendingAmountFC" :editor="editor" :enabled="false" decimals="0" />         
              </div>             
              <Grid ref="paymentJournalListBox" storageKey="paymentJournalList" :items="paymentJournals" :captions="paymentTabCaptions" :widths="paymentTabWidths" >
                <GridItem :slot="paymentTabSlots[0]" slot-scope="{item}"><Badge :value="item.state" list="sendPaymentStatus"/></GridItem>
                <GridItem :slot="paymentTabSlots[1]" slot-scope="{item}">
                  <a class="cx_link_item" @click="onPaymentNoClick(item.creditVoucherNo)">{{ item.creditVoucherNo }}</a>
                </GridItem>
                <GridItem :slot="paymentTabSlots[2]" slot-scope="{item}">{{ item.bookDate | date }}</GridItem>
                <GridItem :slot="paymentTabSlots[3]" slot-scope="{item}">{{ item.currencyCode | currency }}</GridItem>
                <GridItem :slot="paymentTabSlots[4]" slot-scope="{item}">{{ item.bookRate }}</GridItem>
                <GridItem :slot="paymentTabSlots[5]" slot-scope="{item}">{{ item.amountFC  | amountFC(item.currencyCode)}}</GridItem>
                <GridItem :slot="paymentTabSlots[6]" slot-scope="{item}">{{ item.creditAmount | amount}}</GridItem>
              </Grid>
            </template>
          </EditPanel>
        </template>
        <!-- ワークフロータブ -->
        <template slot="tab6" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab7" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
        <!-- 添付ファイルタブ -->
        <template slot="tab8" slot-scope="{ item, editor }">
          <ListFiles :editor="editor" title="添付ファイル" :height="300" :parentKey="item.auditName" :parentId="item.auditNo" :electronicBookMode="tenantSettings.electronicBookMode" />
        </template>
      </Editor>
      <!-- 支払処理ダイアログ -->
      <ListDialog ref="advancePaymentDialog" title="支払処理" modelName="Order" :captions="['発注番号', '支払可能額', '支払額']" :widths="[150, 130, 130,]" :showAdd="false" :showRemove="false" :exec="submitAdvancePayment" >
        <!-- 支払処理ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <!-- <AtcSegment title="部門" :value.sync="apSegment" :editor="editor" :required="true" /> -->
          <ComboBox title="ワークフロー" :value.sync="apWorkflowId" :editor="editor" list="workflow_sendPayment" :required="true" :enabled="$api.perms.hasWorkflow('sendPayment')" :nullValue="0" />          
          <AutoComplete title="担当者" :value.sync="apPic" :editor="editor" list="user" :required="true" />
          <AtcCounterpart title="仕入先" :value.sync="apCounterpart" :editor="editor" :needsSupplier="true" :enabled="false" />
          <AutoComplete title="取引通貨" :value.sync="apCurrencyCode" :editor="editor" list="currency" :enabled="false" v-if="hasLicenseCurrency"/>
          <Calendar title="支払日" :value.sync="apPaymentDate" :editor="editor" :required="true" @changed="onChangeApCurrency" />
          <AtcBankAccount title="支払口座" :value.sync="apBankAccount" :editor="editor" :required="true" />
          <NumericBox title="支払レート" :value.sync="apExchageRate" v-if="hasLicenseCurrency" :editor="editor" :nullValue="0" :required = "true" />
        </template>
        <template slot="footer" slot-scope="{ editor }">
          <NumericBox title="決済金額" :value="apSettlementAmountFC" :enabled="false" decimals="2" />          
          <NumericBox title="手数料額" :value.sync="apCommissionAmountFC" :editor="editor" min="0" max="99999999999" decimals="2" />          
          <NumericBox title="口座支払額" :value="apPaymentAmountFC" :enabled="false" decimals="2" />
          <!-- <template v-if="hasLicenseCurrency">
            <ComboBox title="手数料額課税区分" :value.sync="apCommissionTaxFlag" :editor="editor" list="commissionTaxFlag" :required="true" :showDefault="false" />
          </template> -->
        </template>        
        <!-- 支払処理ダイアログ 一覧項目 -->
        <TextBox slot="col0" slot-scope="{ item, editor }" :value="item.orderNo" :editor="editor" :enabled="false" />
        <NumericBox slot="col1" slot-scope="{ item, editor }" :value.sync="item.advancePendingBalanceAmountFC" :editor="editor" :enabled="false" :nullValue="0" decimals="2" />
        <NumericBox slot="col2" slot-scope="{ item, editor }" :value.sync="item.writeoffAmountFC" :editor="editor" :required="true" :min="0" :max="item.advancePendingBalanceAmountFC" decimals="2" />
      </ListDialog>
      <!-- 明細一括入力ダイアログ -->
      <ListDialog ref="bundleAddOrderItemDialog" title="明細一括入力" modelName="PurchaseOrderItem"
        :captions="dlgConfig.gridCaptions"
        :widths="dlgConfig.gridWidths"
        :showAdd="true" :showRemove="true" :exec="submitBundleAddOrderItem" :height="235" :width="1000" v-if="listView.selected">
        <!-- 明細一括入力ダイアログ 一覧項目 -->
        <AtcCommodity :slot="dlgConfig.gridSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :required="true" @update:value="onChangeCommodity(item)" :onCreate="onItemCreate"/>
        <TextBox :slot="dlgConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.commodityName" :editor="editor" length="100" />
        <!-- <TextBox :slot="col1" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodityName" :required="true" /> -->
        <!-- <TextBox :slot="col2" slot-scope="{ item, editor }" :value="(item.commodity != null ? item.commodity.isNoStock : false) | isNoStock" :editor="editor" :enabled="false" /> -->
        <AtcSKU :slot="dlgConfig.gridSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" @update:value="getPriceAndTaxCode(item)" />
        <AtcConversion :slot="dlgConfig.gridSlots[3]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.uom2" :commodity="item.commodity" :required="true" @update:value="getPriceAndTaxCode(item)" /> 
        <NumericBox :slot="dlgConfig.gridSlots[4]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" :min="(item.commodity && item.commodity.isNoStock) ? -99999999.999 :0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" :nullValue="0" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="dlgConfig.gridSlots[5]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.unitPrice" :required="!tenantSettings.noCheckPriceRequired" min="-999999999.999999" max="999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" />
        <AtcTaxCode :slot="dlgConfig.gridSlots[6]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.taxCode" :taxType="listView.selected.counterpart.taxType" list="taxCode" :required="true" />
        <CheckBox :slot="dlgConfig.gridSlots[7]" slot-scope="{ item, editor }" :value.sync="item.isNCV" :editor="editor" list="isTarget" :showDefault="false" />
        <!-- <TextBox :slot="col9" slot-scope="{ item, editor }" :value.sync="item.description" :editor="editor" length="200" /> -->
        <Calendar :slot="dlgConfig.gridSlots[8]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.answerDeliveryDate" :deletable="true" />
        <Calendar :slot="dlgConfig.gridSlots[9]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.scheduledDeliveryDate" :deletable="true" />

        <TextBox :slot="dlgConfig.gridSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)"  />
        <TextBox :slot="dlgConfig.gridSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)"  />
        <TextBox :slot="dlgConfig.gridSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgConfig.gridSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgConfig.gridSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgConfig.gridSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgConfig.gridSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgConfig.gridSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgConfig.gridSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgConfig.gridSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgConfig.gridSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgConfig.gridSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgConfig.gridSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgConfig.gridSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgConfig.gridSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgConfig.gridSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgConfig.gridSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <TextBox :slot="dlgConfig.gridSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="dlgConfig.gridSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgConfig.gridSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgConfig.gridSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgConfig.gridSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgConfig.gridSlots[21]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <Calendar :slot="dlgConfig.gridSlots[21]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="dlgConfig.gridSlots[22]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[22]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[23]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[23]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[24]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[24]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
      </ListDialog>
      <!-- SKU一括入力ダイアログ -->
      <ListDialog ref="skuBundleAddOrderItemDialog" title="SKU一括入力" modelName="PurchaseOrderItem"
      :captions="dlgSkuConfig.gridCaptions"
      :widths="dlgSkuConfig.gridWidths"
      :showAdd="false" :showRemove="false" :exec="submitSkuBundleAddOrderItem" 
      :height=220 v-if="listView.selected">
        <!-- SKU一括入力ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <AtcCommodity title="商品" :value.sync="sbaoiHeaderItem.commodity" :editor="editor" :required="true" @update:value="onChangeCommodity2(sbaoiHeaderItem.commodity)" tooltip="登録する商品を選択します。【商品一覧】のデータを選択できます。"/>
          <TextBox title="商品名称" :value.sync="sbaoiHeaderItem.commodityName" :editor="editor" :required="true" length="100" tooltip="初期値は【商品】で選択した商品の【商品名称】が表示されますが､任意で変更が可能です。"/>
          <CheckBox title="棚卸対象" :value.sync="sbaoiHeaderItem.isNoStock" :editor="editor" list="isNoStock" :enabled="false" tooltip="【商品】で選択した商品の【棚卸商品区分】が表示されます。"/>
          <AtcConversion title="単位" :value.sync="sbaoiHeaderItem.uom2" :commodity="sbaoiHeaderItem.commodity" :required="true" @update:value="onChangePackage()" tooltip="【商品】に対応した単位が選択可能です。【商品一覧】に登録されている【計上単位】､【荷姿一覧】に登録した単位が表示されます。"/>
          <AtcTaxCode title="税区分" :value.sync="sbaoiHeaderItem.taxCode" :editor="editor" :taxType="listView.selected.counterpart.taxType"  list="taxCode" :required="true" tooltip="登録する税区分を選択します。【税区分一覧】のデータを選択できます。"/>
        </template>
        <!-- SKU一括入力 一覧項目 -->
        <AtcSKU :slot="dlgSkuConfig.gridSlots[0]" slot-scope="{ item, editor }" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="false" />
        <NumericBox :slot="dlgSkuConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.quantity" :editor="editor"  :min="(item.commodity && item.commodity.isNoStock) ? -99999999.999 :0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="dlgSkuConfig.gridSlots[2]" slot-scope="{ item, editor }" :value.sync="item.unitPrice" :editor="editor" :required="!tenantSettings.noCheckPriceRequired && item.quantity != 0" min="-999999999.999999" max="999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" />
        <TextBox :slot="dlgSkuConfig.gridSlots[3]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[3]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[4]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[4]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[5]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[5]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
      </ListDialog>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseOrderView extends Vue {
  public createPurchaseDelivery = Components.CreatePurchaseDelivery;
  public items: Common.PurchaseOrder[] = new Array(0);
  public params: Common.OrderQuery = new Common.OrderQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.OrderImportQuery('発注',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.OrderExportQuery('発注', this.params,Common.SalesPurchaseFlags.Purchase);
  public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'orderNo', text: '発注番号' },
    { value: 'orderDate', text: '発注日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'requestDate', text: '希望納期' },
    { value: 'warehouse', text: '入庫倉庫' },
    { value: 'receiver', text: '納入先' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '発注管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true];
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false, false];    
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseImport: boolean = false;
  public voucherTypes = Common.voucherTypes;
  public DeliveryFlags = Common.DeliveryFlags;
  @Prop() public orderNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public dlgConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//明細一括入力
  public dlgSkuConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//SKU一括入力

  // ライセンスによって表示の切り替わる項目
  // public licenseCurrencyGridItems: Common.GridItemConfiguration[] = [
  //     new Common.GridItemConfiguration('取引通貨', 120)
  // ];
  // public variableGridItems: Common.GridItemConfiguration[] = [
  //     new Common.GridItemConfiguration('税計算区分', 120),
  //     new Common.GridItemConfiguration('発注金額', 120)
  // ];
  // public licenseImportGridItems: Common.GridItemConfiguration[] = [
  //     new Common.GridItemConfiguration('前払金請求額', 150),
  //     new Common.GridItemConfiguration('前払金請求残高', 150),
  //     new Common.GridItemConfiguration('前払金残高', 120),
  //     new Common.GridItemConfiguration('支払予定日', 120)
  // ];

  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('支払伝票番号', 150),
      new Common.GridItemConfiguration('支払日', 120),
    ],
    3, // 入金日の次を可変表示項目の挿入位置に指定
    'col'
  );
  // ライセンスによって表示の切り替わる項目
  public paymentTabVariableGridItems1: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払通貨', 150),
    new Common.GridItemConfiguration('支払レート', 150)
  ];
  public paymentTabVariableGridItems2: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払金額', 150)
  ];
  public paymentTabVariableGridItems3: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払計上額', 150)
  ];

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseImport = this.$api.hasLicense(Common.licenseFlags.import);

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('発注番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 150),      
      new Common.GridItemConfiguration('発注日', 120),
      new Common.GridItemConfiguration('仕入先', 120),
      new Common.GridItemConfiguration('希望納期', 120),
      new Common.GridItemConfiguration('納入区分', 120),      
      new Common.GridItemConfiguration('入庫倉庫', 120),
      new Common.GridItemConfiguration('納入先', 120),    
      new Common.GridItemConfiguration('取引通貨', 120,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('発注金額', 120),
      new Common.GridItemConfiguration('税計算区分',120),
      new Common.GridItemConfiguration('受注区分', 120),      
      new Common.GridItemConfiguration('案件', 150),              
      new Common.GridItemConfiguration('部門', 120),
      new Common.GridItemConfiguration('担当者', 120),
      new Common.GridItemConfiguration('発注管理番号', 150),

      new Common.GridItemConfiguration('前払金請求額', 150,this.hasLicenseImport),
      new Common.GridItemConfiguration('支払予定日', 120,this.hasLicenseImport),
      new Common.GridItemConfiguration('前払金請求残高', 150,this.hasLicenseImport),
      new Common.GridItemConfiguration('前払金残高', 120,this.hasLicenseImport),
      new Common.GridItemConfiguration('前払金消込額(確定待ち)',180,this.hasLicenseImport),
      new Common.GridItemConfiguration('インポート番号', 100),      
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 120),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 120)
    );

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseImport = this.hasLicenseImport;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseImport = this.hasLicenseImport;
    // タブ表示の制御
    this.$set(this.tabVisibles, 5, this.hasLicenseImport); // 支払情報タブ
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction); // 予備項目タブ

    // 支払情報タブの表示項目制御
    this.paymentTabVariableGridItems1.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems3.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems2);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems3);
    this.paymentTabGridConfig.setVariableItems(this.paymentTabVariableGridItems1);
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;
    //明細一括入力用のグリッド
    // this.dlgConfig.setGridItemsFromCaptions(
    //   ['商品',  'SKU', '単位', '発注数量', '単価', '税区分', 'NCV', '回答納期', '入荷予定日'],
    //   [250, 200, 120, 130, 130, 120, 90, 130, 130]
    // );
    this.dlgConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200,this.$api.useStockFunction),
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('発注数量', 130),
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('NCV', 90,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('回答納期', 130),
      new Common.GridItemConfiguration('入荷予定日', 130),
    )
    this.dlgConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ
  //SKU一括入力用のグリッド
    this.dlgSkuConfig.setGridItemsFromCaptions(
      ['SKU', '受注数量', '単価'],
      [150, 150, 150]
    );
    this.dlgSkuConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ
  //SKU一括入力用のグリッド

    // 検索条件を設定する
    if(this.orderNo){
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
        
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseDelivery');
    this.$api.formatter.ensureListLoaded('workflow_purchaseInvoice');
    this.$api.formatter.ensureListLoaded('workflow_sendPayment');
  }

  public async onCreate(obj: Common.PurchaseOrder) {
    const workflows = this.$api.formatter.getOptions('workflow_purchaseOrder');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    obj.deliveryFlag = this.$api.useStockFunction ? Common.DeliveryFlags.Stock : Common.DeliveryFlags.Services;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //発注明細タブのリロード
    (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 状態から編集可能か判別する
  public isStock = Common.DeliveryFlags.Stock;
  public isDirect = Common.DeliveryFlags.Direct;
  public isEditable(item: Common.PurchaseOrder, shouldCheckOrderFlag: boolean, checkDeliveryFlag: Common.DeliveryFlags = null):boolean{
    if(shouldCheckOrderFlag && item.orderFlag == false) return false;
    if(checkDeliveryFlag != null && item.deliveryFlag != checkDeliveryFlag) return false;
    if(item.state == Common.OrderStatus.PurchaseOrderSaving) return true;
    return false;
  }
  // 完了以外の状態で編集可能
  public isEditableNoComplete(item: Common.PurchaseOrder)
  {
    if(item.state == Common.OrderStatus.PurchaseOrderCompleted) return false;
    return true;
  }

  // 仕入先変更時に仕入先の通貨を設定する
  public onChangeCustomer(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    item.onChangeCounterpart();
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }
  // 入庫そうお変更時に納入先詳細を設定する
  public onChangeWarehouse(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeWarehouse();
  }
  // 納入区分変更時にクリアする
  public onChangeDeliveryFlag(item: Common.Order){
    if (item.deliveryFlag == Common.DeliveryFlags.Stock) item.receiver = null;
    else item.warehouse = null;
  }
  // 一覧でチェックされている発注伝票
  public checkedOrders: Array<Common.Order>= new Array(0);
  public getCheckedOrders(){
    this.checkedOrders = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedOrders.push(obj);
      }
    });
  }

  // 一覧選択時に明細表示ボタンを非活化状態・支払情報タブを更新
  public onSelectedMain(index: number, selected: Common.Order) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);

    // 支払情報タブを更新
  this.totalPaymentAmountFC = 0;
  this.totalPendingAmountFC = 0;
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
  }

  // 支払処理用プロパティ
  public apSegment: Common.Segment = null;
  public apPic: string = '';
  public apWorkflowId :number = 0;
  public apCounterpart: Common.Counterpart = null;
  public apCurrencyCode: string = '';
  public apPaymentDate :Date = null;
  public apBankAccount: Common.BankAccount = null;
  public apExchageRate: number = 0;
  public get apPaymentAmountFC(): number { return this.apSettlementAmountFC + this.apCommissionAmountFC; };
  public apCommissionAmountFC: number = 0;
  public apCommissionTaxFlag: boolean = false;
  public get apSettlementAmountFC(): number {
    if(this.checkedOrders.length == 0) return 0;
    return this.checkedOrders.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };

  // 支払処理ダイアログの表示
  public showAdvancePaymentDialog() {
    this.getCheckedOrders();

    // ダイアログ表示前バリデーション
    if(this.checkedOrders.length == 0){
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].counterpart.id != order.counterpart.id).length > 0){
      this.$api.modal.show('', '同一仕入先の発注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].currencyCode != order.currencyCode).length > 0){
      this.$api.modal.show('', '同一取引通貨の発注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].segmentId != order.segmentId).length > 0){
      this.$api.modal.show('', '同一部門の発注伝票を選択して下さい。', true, null);
      return;
    }        
    if(this.checkedOrders.filter(order=> (order.state & (Common.OrderStatus.PurchaseOrderPaymentWaiting | Common.OrderStatus.PurchaseOrderPartialPaymentWaiting)) <= Common.OrderItemStatus.PurchaseOrder).length > 0){
      this.$api.modal.show('', '前払金支払待ち、または前払金一部支払の発注伝票を選択して下さい。', true, null);
      return;
    }

    // 入力項目の初期化
    this.apSegment = this.checkedOrders[0].segment; //発生部門をセット(非表示)
    this.apPic = this.$api.auth.userId;    
    this.apWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_sendPayment');
    this.apCounterpart = this.checkedOrders[0].counterpart;
    this.apCurrencyCode = this.checkedOrders[0].currencyCode;
    this.apPaymentDate = this.checkedOrders.map(order => order.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.apExchageRate = 1;
    this.apCommissionAmountFC = 0;
    this.apCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeApCurrency();
    this.getBankAccount();

    // ダイアログの表示
    (this.$refs.advancePaymentDialog as Components.ListDialog).items = this.checkedOrders;
    (this.$refs.advancePaymentDialog as Components.ListDialog).showDialog();
  }

  public async onChangeApCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.apCurrencyCode;
    query.startDate = this.apPaymentDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.apExchageRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

   public async getBankAccount(){
    const query = new Common.GetBankAccount();
    query.currencyCode = this.apCurrencyCode;
    this.$api.execute(query).then(res => {
      this.apBankAccount = res as Common.BankAccount;
    });
  }

  // 支払処理の実行
  public async submitAdvancePayment(list: Array<Common.Order>)
  {
    // クエリの設定
    var query = new Common.AdvancePaymentQuery();
    query.segment = this.apSegment;
    query.pic = this.apPic;
    query.workflowId = this.apWorkflowId;
    query.counterpart = this.apCounterpart;
    query.currencyCode = this.apCurrencyCode;
    query.paymentDate = this.apPaymentDate;
    query.bankAccount = this.apBankAccount;
    query.exchangeRate = this.apExchageRate;
    query.commissionAmountFC = this.apCommissionAmountFC;
    query.settlementAmountFC = this.apSettlementAmountFC;
    query.commissionTaxFlag = this.apCommissionTaxFlag;    
    query.orders = list;

    // 支払処理後、支払一覧へ画面遷移
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',(res as Common.Payment).paymentNo));      
    // });
    return this.$api.execute(query,true).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      var payment = res as Common.Payment;
      //支払明細タブのリロード
      this.refreshPaymentList();
      this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))]);
      return true;
    }).catch(()=>{return false;});        
  }

  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseOrder){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseOrder, sourceNo : item.orderNo},this.$el);
  }

  // 発注明細一覧へ遷移する
  public showPurchaseOrderItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseOrderItem?orderNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');  
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  updateDisabledShowItemButton(order:Common.Order){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetOrderItemQuery();
    query.orderNo = order.orderNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 入荷明細表示ボタンの非活性制御
  public disabledShowPurchaseDeliveryItemButton(item: Common.Order):boolean{
    return item.state != Common.OrderStatus.PurchaseOrderCompleted;
  }

  // 入荷明細一覧へ遷移する
  public showPurchaseDeliveryItem(){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    if(obj) {
      let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?orderNo={0}', obj.orderNo));
      window.open(routeData.href, '_blank');
    }
  }

  // 明細一括入力・SKU一括入力ボタンの非活性判別
  public disabledAddItemButton(order:Common.PurchaseOrder){
    return order.state >= Common.OrderStatus.PurchaseOrderItemsOperateWaiting;
  }

  // 明細一括入力ダイアログを表示
  public showBundleAddOrderItemDialog() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;    
    // 新規の場合にチェック
    if(parent.counterpart == null){
      this.$api.modal.show('', '仕入先を指定してください。', true, null);
      return ;
    }
     var items = new Array();
    var instance = new Common.PurchaseOrderItem();
    instance.taxCode = parent.counterpart.taxCode;
    items.push(instance);
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable2(usedType: Common.UsedTypes){
    //商品識別情報,受発注メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.OrderMemo )  return true; else return false;
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.OrderItem){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Order;
    this.$api.execute(new Common.OrderGetItemPriceQuery(parent, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }
  //行追加時に税区分の初期値を設定
  public async onItemCreate(obj:Common.PurchaseOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }
public submitBundleAddOrderItemRun(){
  const items = (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).items;
  if(items.length > 0) this.submitBundleAddOrderItem(items);
}
  // 明細一括入力の実行
  public async submitBundleAddOrderItem(list: Array<Common.PurchaseOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    var items = new Array();
    await list.forEach(async obj => {
      obj.order = parent;
      items.push(obj);
    });
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Purchase);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/purchase/PurchaseOrderItem?orderNo={0}', parent.orderNo));
    // });

    return this.$api.execute(query).then(res => {
      //発注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //発注明細タブのリロード
        (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        //事後アクションダイアログを表示するためコメントアウト 
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      });
      return true;
    }).catch(()=>{return false;});    
  }

  // SKU一括入力プロパティ
  public sbaoiHeaderItem: Common.PurchaseOrderItem = new Common.PurchaseOrderItem();
  // SKU一括入力ダイアログを表示
  public showSkuBundleAddOrderItemDialog() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;    
    this.sbaoiHeaderItem = new Common.PurchaseOrderItem();
    this.sbaoiHeaderItem.taxCode = parent.counterpart.taxCode;//税区分初期値をセット
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array();
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }

  // 商品変更時に連動更新項目をサーバー側で行いそれを設定する
  public onChangeCommodity2(commodity:Common.Commodity){
    // 明細を初期化
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array(0);

    // 商品に連動する項目の取得
    this.sbaoiHeaderItem.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(this.sbaoiHeaderItem);

    if(this.sbaoiHeaderItem != null && this.sbaoiHeaderItem.commodity != null){
      // 選択した商品のSKUを一括取得
      var query = new Common.SKUMasterQuery();
      query.commodityId = this.sbaoiHeaderItem.commodity.id;
      this.$api.execute(query).then(res => {
        // SKUごとに明細を作成
        for(var sku of res.result){
          var item = (this.sbaoiHeaderItem as Common.StateObject2).copy();
          item.sku = sku as Common.SKU;
          this.getPriceAndTaxCode(item);
          (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items.push(item);
        }
      });
      // 明細を更新
      (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).$forceUpdate();
    }
  }

  // 単位変更時に単価・税区分を取得する
  public onChangePackage(){
    for(var item of (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items){
      item.package = this.sbaoiHeaderItem.package;
      this.getPriceAndTaxCode(item);
    }
  }

  // SKU一括入力の実行
  public async submitSkuBundleAddOrderItem(list: Array<Common.PurchaseOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    var items = new Array();
    for(var obj of list){
      if(obj.quantity == 0) continue;
      obj.order = parent;
      // ダイアログのヘッダ部の内容を設定
      obj.commodity = this.sbaoiHeaderItem.commodity;
      obj.commodityName = this.sbaoiHeaderItem.commodityName;
      obj.package = this.sbaoiHeaderItem.package;
      obj.taxCode = this.sbaoiHeaderItem.taxCode;
      items.push(obj);
    }
    
    if(items.length == 0){
      return this.$api.modal.showDialog('', 'いずれかの行で発注数量を指定して下さい。').then(()=>false);
    }
      //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Purchase);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/purchase/PurchaseOrderItem?orderNo={0}', parent.orderNo));
    // });
    return this.$api.execute(query).then(res => {
      //発注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res);
      //発注明細タブのリロード
       (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();       
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});      
  }

  // 支払情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPaymentAmount:number = 0;
  public totalPendingAmountFC:number = 0;  
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 支払情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffAmount = 0;
    var totalWriteoffPendingAmountFC = 0;    
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = (this.$refs.mainList as Components.ListView).selected.orderNo;
    query.isSend = true;

    // サーバーから支払情報を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.paymentJournals = res.result;
        this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            totalWriteoffAmount += obj.creditAmount;
            obj.state = Common.PaymentStatus.PaymentCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentPostWaiting;            
          }
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPaymentAmount = totalWriteoffAmount;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;      
    });
  }

  // 支払一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Withdrawal?paymentNo={0}',paymentNo));
  }
  // チェックされている発注明細を取得する
  public selectedPurchaseOrderItems(){
    return (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).selectedItems;
  }
  public allPurchaseOrderItems(){
    return (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).items;
  }  
  // 入荷処理・未着品処理ボタンの非活性判別
  public  disabledOrderItemFuncButton(order:Common.PurchaseOrder):boolean{
    return order.state == Common.OrderStatus.PurchaseOrderSaving || order.state == Common.OrderStatus.PurchaseOrderCompleted;
  }
  // 明細クローズ解除処理ボタンの非活性判別
  public  disabledOrderItemCloseCancelFuncButton(order:Common.PurchaseOrder):boolean{
    return order.state == Common.OrderStatus.PurchaseOrderSaving;
  }

  // 入荷処理ダイアログの表示
  public showCreatePurchaseDelivery(isTransitPost:boolean, all:boolean = false)
  {
    var router = this.$router;
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    let componentClass = Vue.extend(this.createPurchaseDelivery);
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: all ? this.allPurchaseOrderItems() : this.selectedPurchaseOrderItems(),
          purchaseOrderItems: this.$refs.purchaseOrderItems,
          parentMainList: this.$refs.mainList,
          isTransitPost: isTransitPost,
          order: obj,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 明細クローズ処理
  public async itemClosedQuery(isClose:boolean) {
    var selectedItems:Array<Common.PurchaseOrderItem>;
    selectedItems = this.selectedPurchaseOrderItems();
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    var targetItems:Array<Common.PurchaseOrderItem>;
    targetItems=new Array();

    // クローズ処理：注残あり、クローズ解除処理：クローズ数量あり
    if(isClose == true){
      selectedItems.forEach(item =>{
        if(item.backOrderQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', '発注残数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }else{
      selectedItems.forEach(item =>{
        if(item.closedQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', 'クローズ数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }

return this.$api.modal.showDialog('確認',String.format('選択された発注明細の{0}を0にします。よろしいですか？',isClose?'発注残数量':'クローズ数量'),false).then(()=>{
      var query = new Common.OrderItemCloseQuery();
      query.orderItems = targetItems;
      query.isClose = isClose;
      return this.$api.execute(query).then(res =>{
        //発注残・ステータスが更新されるのでリストを更新する
        (this.$refs.mainList as Components.ListView).onSubmit(res);
        //発注明細タブのリロード
        (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        this.$api.modal.show('処理結果','処理が完了しました。',true,null);
        return true;
      }).catch(()=>{return false;});;
    });
  }

}
</script>

<style lang="scss">

</style>